import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Promise.withResolvers is a recent addition (Chromium 119+, mid-2024) that pdfjs-dist v4
// relies on internally. The mobile app's embedded WebView (Android System WebView) can lag
// well behind desktop browser versions — this emulator ships Chromium 113 — where it's
// missing entirely, throwing "Promise.withResolvers is not a function" and breaking the
// Colorado form PDF editor (ColoradoFormPdfEditor.js) for any user on an older
// browser/WebView. Polyfilled globally, before anything else runs, since this method has no
// side effects and any caller anywhere in the app may need it.
if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function withResolvers() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
